import { http } from './http';
import type { ApiResponse, AuthPayload, User } from '@/types/api';

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegisterInput {
  email: string;
  password: string;
  name: string;
  role?: User['role'];
}

export interface UpdateProfileInput {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  alternativeMobile?: string;
  officeCug?: string;
  officeEmail?: string;
  address?: string;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const authService = {
  async login(input: LoginInput): Promise<AuthPayload> {
    const res = await http.post<ApiResponse<AuthPayload>>('/auth/login', input);
    return res.data.data;
  },
  async register(input: RegisterInput): Promise<AuthPayload> {
    const res = await http.post<ApiResponse<AuthPayload>>('/auth/register', input);
    return res.data.data;
  },
  async me(): Promise<User> {
    const res = await http.get<ApiResponse<User>>('/auth/me');
    return res.data.data;
  },
  async updateProfile(input: UpdateProfileInput): Promise<User> {
    const res = await http.patch<ApiResponse<User>>('/auth/me', input);
    return res.data.data;
  },
  async changePassword(input: ChangePasswordInput): Promise<void> {
    await http.post('/auth/change-password', input);
  },
  async logout(refreshToken?: string) {
    await http.post('/auth/logout', { refreshToken });
  },
};
